import { useQuery } from '@tanstack/react-query';
import {
  fetchPlatformImpact,
  type PlatformImpact,
} from '../services/platformImpact';

export const PLATFORM_IMPACT_QUERY_KEY = ['public', 'platform-impact'] as const;

export function usePlatformImpact(initialData?: PlatformImpact) {
  return useQuery({
    queryKey: PLATFORM_IMPACT_QUERY_KEY,
    queryFn: fetchPlatformImpact,
    initialData,
    staleTime: 5 * 60_000,
    refetchInterval: 5 * 60_000,
  });
}
